import React from 'react';
import { undoRedoModifierLabel } from '../tree-domain/useUndoRedoShortcuts';
import { UndoIcon, RedoIcon } from '../ui/icons';

interface EditStatusControlsProps {
  showDraft: boolean;
  onUndo: () => void;
  onRedo: () => void;
  canUndo: boolean;
  canRedo: boolean;
}

/**
 * DRAFT badge plus undo/redo buttons for the tree editor. TreeEdit builds this
 * cluster once and decides where it renders — the wide control bar's editStatus
 * slot, or the dev panel bar on narrow viewports so the tree name keeps its space.
 * Whether to render at all (loading, edit mode) is the caller's decision.
 */
export const EditStatusControls: React.FC<EditStatusControlsProps> = ({
  showDraft,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
}) => {
  const modifier = undoRedoModifierLabel();
  const undoLabel = `Undo (${modifier}+Z)`;
  const redoLabel = `Redo (${modifier}+Shift+Z)`;

  return (
    <>
      {showDraft && <span className="draft-label">DRAFT</span>}

      <div className="undo-redo-group">
        <button
          onClick={onUndo}
          className="btn btn-secondary btn-icon"
          disabled={!canUndo}
          aria-label={undoLabel}
          title={undoLabel}
        >
          <UndoIcon />
        </button>
        <button
          onClick={onRedo}
          className="btn btn-secondary btn-icon"
          disabled={!canRedo}
          aria-label={redoLabel}
          title={redoLabel}
        >
          <RedoIcon />
        </button>
      </div>
    </>
  );
};
